"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2031],{

/***/ 42031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export HeadChannel */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48309);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7806);
/* harmony import */ var _constants_business__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56154);
/* harmony import */ var _constants_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8829);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);








var HeadChannel;
(function(HeadChannel) {
    HeadChannel["Graph"] = "Graph";
    HeadChannel["Twitter"] = "Twitter";
})(HeadChannel || (HeadChannel = {}));
// Tiêu đề/mô tả từ WordPress có sẵn entity (&#8211; &nbsp; &amp;) → giải mã để Google hiển thị đúng
var ENTITIES = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    nbsp: " ",
    ndash: "–",
    mdash: "—",
    hellip: "…"
};
var ref;
var decodeEntities = function(s) {
    return (s || "").replace(/&#(x?)([0-9a-f]+);/gi, function(_, x, n) {
        return String.fromCodePoint(parseInt(n, x ? 16 : 10));
    }).replace(/&([a-z]+);/gi, function(m, n) {
        return (ref = ENTITIES[n.toLowerCase()]) !== null && ref !== void 0 ? ref : m;
    }).replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
};
var MasterDataDefault = {
    author: "C\xf4ng ty TNHH An Thư The Diamond Store",
    keywords: "Kim cương, an thu, kim cương an thư, nhẫn kim cương, v\xf2ng cổ kim cương, b\xf4ng tai kim cương, d\xe2y chuyền kim cương, gi\xe1 kim cương, hoa tai kim cuong, kim cuong cao cap, lac tay kim cuong, lắc tay kim cương, trang sức kim cương, vong tay kim cuong, v\xf2ng tay kim cương, vong tay kim cuong",
    copyright: "C\xf4ng ty TNHH An Thư The Diamond Store",
    generator: "C\xf4ng ty TNHH An Thư The Diamond Store"
};
var MetaTag = function(param) {
    var rawTitle = param.title, _titleBrand = param.titleBrand, titleBrand = _titleBrand === void 0 ? _constants_business__WEBPACK_IMPORTED_MODULE_5__/* .BUSINESS.brand */ .aL.brand : _titleBrand, rawDescription = param.description, image = param.image, type = param.type, productCode = param.productCode, productId = param.productId, price = param.price, category = param.category, categoryName = param.categoryName, material = param.material, status = param.status, _blacklist = param.blacklist, blacklist = _blacklist === void 0 ? [] : _blacklist, handle = param.handle, seo = param.seo, _noindex = param.noindex, noindex = _noindex === void 0 ? false : _noindex, schemaDescription = param.schemaDescription;
    var ref, ref1, ref2, ref3, ref4;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_1__/* .useMasterData */ .AE)();
    var title = decodeEntities(rawTitle);
    var description = rawDescription ? decodeEntities(rawDescription) : rawDescription;
    // useRouter (không dùng Router singleton): lúc SSR singleton chưa có asPath → canonical mọi trang bị trỏ về trang chủ
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var getLocale = function(l) {
        if (l === "en") return "en_US";
        return "vi_VN";
    };
    var fbDomainVerification = "5lglihkbcrqwrvoto1yedw9itcr5t3";
    var FB_PAGE_ID = "138153763641280" || 0;
    var APP_URL = "https://anthu.vn" || 0;
    // trailingSlash: true trong next.config → URL chuẩn luôn có "/" ở cuối
    var withSlash = function(p) {
        var path = (p || "/").split("#")[0];
        return path.endsWith("/") ? path : path + "/";
    };
    var ref5;
    var cleanPath = withSlash((ref5 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]) !== null && ref5 !== void 0 ? ref5 : "/");
    var href = APP_URL + (handle ? withSlash(handle) : cleanPath);
    var BRAND = _constants_business__WEBPACK_IMPORTED_MODULE_5__/* .BUSINESS.brand */ .aL.brand;
    var titleSuffix = decodeEntities(titleBrand) || BRAND;
    // title đã kết thúc bằng brand ("| An Thư" hoặc "| An Thư Kim Cương") thì không nối thêm
    var fullTitle = title.endsWith(titleSuffix) || /\|\s*An Thư$/.test(title) ? title : "".concat(title, " | ").concat(titleSuffix);
    var metaTitle = (seo === null || seo === void 0 ? void 0 : seo.title) || fullTitle;
    // Google cắt meta description ~155–160 ký tự → cắt tại ranh giới từ để không bị "…" giữa chữ
    var clampDescription = function(text) {
        var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 158;
        var clean = text.replace(/\s+/g, " ").trim();
        if (clean.length <= max) return clean;
        var cut = clean.slice(0, max - 1);
        return cut.slice(0, Math.max(cut.lastIndexOf(" "), 80)).replace(/[,;:.\-–]+$/, "") + "…";
    };
    var metaDescription = clampDescription((seo === null || seo === void 0 ? void 0 : seo.description) || description || _constants_business__WEBPACK_IMPORTED_MODULE_5__/* .BUSINESS.description */ .aL.description);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Content-Type",
                content: "text/html; charset=utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "+nxGUDJ4QpAZ5l9Bsjdi102tLVC21AIh5d1Nl23908vVuFHs34="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: _constants_seo__WEBPACK_IMPORTED_MODULE_6__/* .SEO_INDEXABLE */ .VR && !noindex && router.locale !== "en" ? _constants_seo__WEBPACK_IMPORTED_MODULE_6__/* .ROBOTS_INDEX */ .z7 : _constants_seo__WEBPACK_IMPORTED_MODULE_6__/* .ROBOTS_NOINDEX */ .Bq
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "nositelinkssearchbox"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: (seo === null || seo === void 0 ? void 0 : seo.keywords) || (masterData === null || masterData === void 0 ? void 0 : (ref1 = masterData.company_info) === null || ref1 === void 0 ? void 0 : ref1.keywords) || MasterDataDefault.keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: (masterData === null || masterData === void 0 ? void 0 : (ref2 = masterData.company_info) === null || ref2 === void 0 ? void 0 : ref2.copyright) || MasterDataDefault.copyright
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: (masterData === null || masterData === void 0 ? void 0 : (ref3 = masterData.company_info) === null || ref3 === void 0 ? void 0 : ref3.author) || MasterDataDefault.author
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "GENERATOR",
                content: (masterData === null || masterData === void 0 ? void 0 : (ref4 = masterData.company_info) === null || ref4 === void 0 ? void 0 : ref4.generator) || MasterDataDefault.generator
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "Document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "distribution",
                content: "Global"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: fbDomainVerification
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: metaDescription
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "audience",
                content: "General"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "x-dns-prefetch-control",
                content: "on"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:pages",
                content: FB_PAGE_ID
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: href
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: "vi",
                href: href
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: href
            }),
            !blacklist.includes(HeadChannel.Graph) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: type === "product" ? "product" : "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: href
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }),
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: _constants_business__WEBPACK_IMPORTED_MODULE_5__/* .BUSINESS.name */ .aL.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: getLocale(router === null || router === void 0 ? void 0 : router.locale)
                    }),
                    type === "product" && price !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "product:price:amount",
                                content: String(price)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "product:price:currency",
                                content: "VND"
                            })
                        ]
                    })
                ]
            }),
            !blacklist.includes(HeadChannel.Twitter) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:url",
                        content: href
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }),
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: image
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify((0,_constants_business__WEBPACK_IMPORTED_MODULE_5__/* .organizationJsonLd */ .JF)())
                }
            }),
            type === "product" && typeof price === "number" && price > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "@id": "".concat(href, "#product"),
                        name: ((seo === null || seo === void 0 ? void 0 : seo.title) || title).trim(),
                        url: href,
                        image: image ? [
                            image
                        ] : undefined,
                        description: schemaDescription || metaDescription,
                        sku: productCode,
                        mpn: productCode,
                        productID: productId,
                        brand: {
                            "@type": "Brand",
                            name: BRAND
                        },
                        material: material || undefined,
                        category: categoryName || category,
                        offers: {
                            "@type": "Offer",
                            url: href,
                            priceCurrency: "VND",
                            price: price,
                            priceValidUntil: (0,_constants_business__WEBPACK_IMPORTED_MODULE_5__/* .priceValidUntil */ .x)(30),
                            itemCondition: "https://schema.org/NewCondition",
                            availability: status === _layouts_shared__WEBPACK_IMPORTED_MODULE_7__/* .ProductStatus.Availability */ .Pt.Availability ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                            seller: {
                                "@id": _constants_business__WEBPACK_IMPORTED_MODULE_5__/* .BUSINESS.id */ .aL.id
                            },
                            // Google Merchant listing: giao hàng miễn phí toàn quốc (policies/shipping-and-delivery), thu đổi tại cửa hàng (policies/refund)
                            shippingDetails: {
                                "@type": "OfferShippingDetails",
                                shippingRate: {
                                    "@type": "MonetaryAmount",
                                    value: 0,
                                    currency: "VND"
                                },
                                shippingDestination: {
                                    "@type": "DefinedRegion",
                                    addressCountry: "VN"
                                }
                            },
                            hasMerchantReturnPolicy: {
                                "@type": "MerchantReturnPolicy",
                                applicableCountry: "VN",
                                returnPolicyCategory: "https://schema.org/MerchantReturnUnspecified",
                                returnMethod: "https://schema.org/ReturnInStore",
                                merchantReturnLink: "".concat(APP_URL, "/policies/refund/")
                            }
                        }
                    })
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(MetaTag));
MetaTag.defaultProps = {
    image: "".concat("https://anthu.vn", "/logo-bg.png"),
    blacklist: [],
    description: "",
    url: "https://anthu.vn"
};


/***/ }),

/***/ 56154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JF": function() { return /* binding */ organizationJsonLd; },
/* harmony export */   "aL": function() { return /* binding */ BUSINESS; },
/* harmony export */   "x": function() { return /* binding */ priceValidUntil; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/**
 * Thông tin doanh nghiệp dùng chung cho SEO / structured data (JSON-LD).
 * Sửa ở đây là đổi trên mọi trang.
 */ 
var APP_URL = "https://anthu.vn" || 0;
var orEnv = function(v, fallback) {
    return v && v !== "#" ? v : fallback;
};
var SOCIAL = {
    facebook: orEnv("https://www.facebook.com/anthukimcuong", "https://www.facebook.com/anthukimcuong"),
    tiktok: orEnv("https://www.tiktok.com/@anthudiamond", "https://www.tiktok.com/@anthudiamond"),
    youtube: orEnv("https://www.youtube.com/@AnThuKimCuong/", "https://www.youtube.com/@AnThuKimCuong/"),
    instagram: orEnv("https://www.instagram.com/anthuthediamondstore/?hl=en", "https://www.instagram.com/anthuthediamondstore/")
};
var BUSINESS = {
    social: SOCIAL,
    appUrl: APP_URL,
    id: "".concat(APP_URL, "/#organization"),
    brand: "An Thư Kim Cương",
    name: "An Thư The Diamond Store",
    alternateName: [
        "An Thư Kim Cương",
        "An Thư Diamond",
        "Kim cương An Thư"
    ],
    legalName: "C\xf4ng ty TNHH An Thư The Diamond Store",
    description: "An Thư The Diamond Store l\xe0 cửa h\xe0ng trang sức kim cương tự nhi\xean tại TP. Hồ Ch\xed Minh, th\xe0nh lập năm 2017. " + "Chuy\xean nhẫn, b\xf4ng tai, d\xe2y chuyền, lắc tay kim cương v\xe0 đ\xe1 qu\xfd; mỗi sản phẩm c\xf3 chứng thư kiểm định, " + "ch\xednh s\xe1ch bảo h\xe0nh v\xe0 thu đổi r\xf5 r\xe0ng. Showroom tại 89A Nguyễn Tr\xe3i, Phường Bến Th\xe0nh (Quận 1 cũ, gần chợ Bến Th\xe0nh), TP. HCM, mở cửa 9:00–21:00 hằng ng\xe0y.",
    foundingDate: "2017-07-07",
    taxId: "0314503621",
    logo: "".concat(APP_URL, "/logo-bg.png"),
    email: "anthutechnology@gmail.com",
    phone: "+84333336789",
    phoneDisplay: "033 333 6789",
    address: {
        streetAddress: "89A Nguyễn Tr\xe3i",
        addressLocality: "Phường Bến Th\xe0nh",
        addressRegion: "Th\xe0nh phố Hồ Ch\xed Minh",
        postalCode: "700000",
        addressCountry: "VN"
    },
    // 89A Nguyễn Trãi, Bến Thành, Q.1 — chỉnh lại nếu Google Maps cho toạ độ khác
    geo: {
        latitude: 10.7686,
        longitude: 106.6929
    },
    hasMap: "https://maps.app.goo.gl/5FCyoAQoAomH6MNp9",
    openingHours: {
        days: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ],
        opens: "09:00",
        closes: "21:00"
    },
    priceRange: "8.000.000 – 300.000.000 VND",
    mapsUrl: "https://maps.app.goo.gl/5FCyoAQoAomH6MNp9",
    sameAs: [
        "https://maps.app.goo.gl/5FCyoAQoAomH6MNp9",
        SOCIAL.facebook,
        SOCIAL.tiktok,
        SOCIAL.youtube,
        SOCIAL.instagram,
        orEnv("https://apps.apple.com/vn/app/anthu/id1613308085?l=vi", "https://apps.apple.com/vn/app/anthu/id1613308085"),
        orEnv("https://play.google.com/store/apps/details?id=com.anthu.diamond", "https://play.google.com/store/apps/details?id=com.anthu.diamond"), 
    ].filter(Boolean)
};
/** JSON-LD Organization + JewelryStore, xuất trên mọi trang qua MetaTag */ var organizationJsonLd = function() {
    return {
        "@context": "https://schema.org",
        "@type": [
            "Organization",
            "JewelryStore"
        ],
        "@id": BUSINESS.id,
        name: BUSINESS.name,
        alternateName: BUSINESS.alternateName,
        legalName: BUSINESS.legalName,
        url: BUSINESS.appUrl,
        logo: {
            "@type": "ImageObject",
            url: BUSINESS.logo
        },
        image: BUSINESS.logo,
        description: BUSINESS.description,
        foundingDate: BUSINESS.foundingDate,
        taxID: BUSINESS.taxId,
        telephone: BUSINESS.phone,
        email: BUSINESS.email,
        address: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
            "@type": "PostalAddress"
        }, BUSINESS.address),
        geo: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
            "@type": "GeoCoordinates"
        }, BUSINESS.geo),
        hasMap: BUSINESS.hasMap,
        areaServed: [
            {
                "@type": "Place",
                name: "Phường Bến Th\xe0nh, Quận 1, TP. Hồ Ch\xed Minh"
            },
            {
                "@type": "City",
                name: "Th\xe0nh phố Hồ Ch\xed Minh"
            },
            {
                "@type": "Country",
                name: "Việt Nam"
            }, 
        ],
        openingHoursSpecification: [
            {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: BUSINESS.openingHours.days,
                opens: BUSINESS.openingHours.opens,
                closes: BUSINESS.openingHours.closes
            }, 
        ],
        priceRange: BUSINESS.priceRange,
        currenciesAccepted: "VND",
        paymentAccepted: "Tiền mặt, Chuyển khoản, Thẻ",
        sameAs: BUSINESS.sameAs,
        contactPoint: [
            {
                "@type": "ContactPoint",
                contactType: "sales",
                telephone: BUSINESS.phone,
                email: BUSINESS.email,
                availableLanguage: [
                    "vi",
                    "en"
                ]
            }, 
        ]
    };
};
/** Ngày hết hạn giá cho Offer: ISO YYYY-MM-DD, luôn ở tương lai */ var priceValidUntil = function() {
    var days = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 30;
    return new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
};


/***/ })

}]);